import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { Item, ItemResponse } from '../interfaces/item.interface';
import {AuthService} from "./auth.service";

export const ItemService = {
    getItemsByInstitution: async (page: number = 0, size: number = 10, search: string = '', kind?: string, sellable?: boolean, nature?: string): Promise<ItemResponse> => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(`${ENDPOINTS.ITEM.LIST_BY_INSTITUTION}/${institutionId}?page=${page}&size=${size}&search=${encodeURIComponent(search)}${kind ? `&kind=${kind}` : ''}${sellable ? '&sellable=true' : ''}${nature ? `&nature=${nature}` : ''}`); // FW-2A: kind / sellable filters
        return response.data;
    },

    createItem: async (item: Item): Promise<void> => {
        await axios.post(ENDPOINTS.ITEM.BASE, item);
    },

    updateItem: async (id: string, item: Item): Promise<void> => {
        await axios.put(ENDPOINTS.ITEM.UPDATE(id), item);
    },

    deleteItem: async (id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.ITEM.DELETE(id));
    },

    /** Q3: one item by id. */
    getById: async (id: string): Promise<Item> => (await axios.get(ENDPOINTS.ITEM.GET(id))).data,

    /** Q3: finds an item in this company by barcode, else by item code. A 404 means no such item. */
    lookup: async (code: string): Promise<Item> => {
        const institutionId = AuthService.getSelectedInstitution();
        return (await axios.get(ENDPOINTS.ITEM.LOOKUP(institutionId!), { params: { code } })).data;
    },

    /** Q3: a free barcode suggested from the item code. */
    suggestBarcode: async (itemCode: string, itemId?: string): Promise<string> => {
        const institutionId = AuthService.getSelectedInstitution();
        const r = await axios.get(ENDPOINTS.ITEM.SUGGEST_BARCODE(institutionId!), { params: { itemCode, itemId } });
        return r.data.barcode;
    }
};
